'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './community-list.routes';

export class CommunityListComponent {
  constructor(Auth, CommunityService, dialogs, $localStorage, DTOptionsBuilder, DTState) {
    'ngInject';

    this.CommunityService = CommunityService;
    this.data = [];

    this.dialogs = dialogs;
    this.$localStorage = $localStorage;

    this.asTable = !!$localStorage.communityListAsTable;

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('dom', 'lBfrtip')
      .withOption('order', [0, 'asc'])
      .withOption('stateSave',true)
      .withOption('stateSaveCallback', DTState.save())
      .withOption('stateLoadCallback', DTState.restore())
      .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
      .withOption('buttons',[{
        extend: 'excel',
        title: "Communities"
      },{
        extend: 'csv',
        title: "Communities"
      },{
        title: "Communities",
        message: 'As of ' + moment().format("MMMM Do YYYY"),
        extend: 'pdf',
        orientation: 'portrait',
        pageSize: 'LETTER'
      },{
        extend: 'print',
        title: "Communities"
      }]);

    this.CommunityService.query((data) => {
      this.data = data;
      this.dataInitComplete = true;
    }, err => {
      console.log("Could not retrieve communities.")
    });
  }

  setAsTable(val) {
    this.asTable = val;
    this.$localStorage.communityListAsTable = val;
  }

  getPrimaryAddress(community, newline) {

    if (!community.address)
      return "-";

    let address = community.address.find(adr => adr.isPrimary) || community.address[0] || {};

    if (!address.city)
      return "-";

    let addBreak = (newline) ? "<br/>": "";

    let adrString = [];

    adrString.push(address.street);
    if (address.street2)
      adrString.push(address.street2);
    adrString.push(addBreak + address.city + ' ' + address.state + ', ' + address.zip);
    if (address.country)
      adrString.push(address.country);

    return adrString.join(', ');
  }

  delete(community) {
    var that = this;

    var communityText = "<br/><br/><b>" + community.code + "</b><br/><p>" + community.name + "</p>";

    var dlg = this.dialogs.confirm("Delete Community?", "Do you really want to delete this community?" + communityText);
    dlg.result.then(() => {
      // OK delete it
      that.CommunityService.delete({id: community._id},
        () => {
          that.data = that.data.filter(function( obj ) {
            return obj._id !== community._id;
          });
        },
        err => {
          alert("Could not delete community");
        });
    }, () => {
      // Cancel
    });
  }

}

export default angular.module('conduu.communityList', [uiRouter])
  .config(routes)
  .component('communityList', {
    template: require('./community-list.html'),
    controller: CommunityListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/portfolio/community-list/community-list.component.js